import React from 'react';
import { useNavigate } from 'react-router-dom';

import {
  FaChartBar,
 
  FaAccusoft,
  FaBookOpen,
  FaFlagCheckered,
  FaPowerOff
} from 'react-icons/fa';

import "./Menu.css";

const Menu = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.clear();
    navigate('/login');
  };
 
  const menuItems = [
    { name: 'Markets', icon: <FaChartBar />, path: '/eventlist' },
 
    { name: 'History', icon: <FaBookOpen />, path: '/history' },
    { name: 'Game Result', icon: <FaFlagCheckered />, path: '/games-result' },
    { name: 'New Cashout', icon: <FaAccusoft />, path: '/newwithdrawals' },

  ];

  return (
    <div className="menu-container">
      {menuItems.map((item, index) => (
        <div
          key={index}
          className="menu-item"
          onClick={() => navigate(item.path)}
        >
          <div className="menu-left">
            <span>{item.icon}</span>                                                                           
            <span className="menu-text">{item.name}</span>
          </div>
        </div>
      ))}

      <button className="logout-btn" onClick={handleLogout}>
        <FaPowerOff /> Logout
      </button>
    </div>
  );
};

export default Menu;